import { useAIMetrics } from '@/hooks/ai';

export function TokenUsagePanel({ provider, sinceHours = 24 }: { provider?: string; sinceHours?: number }) {
  const { data, isLoading, error } = useAIMetrics(provider, sinceHours);

  if (isLoading) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <div className="animate-pulse space-y-3">
          <div className="h-4 bg-gray-200 rounded w-1/3" />
          <div className="h-8 bg-gray-200 rounded" />
          <div className="h-8 bg-gray-200 rounded" />
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-6 text-sm text-gray-500">
        Métricas indisponíveis
      </div>
    );
  }

  const successRate = data.totalCalls > 0 ? Math.round((data.successCount / data.totalCalls) * 100) : 0;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-green-500" />
        Uso de IA ({sinceHours}h)
      </h3>

      <div className="grid grid-cols-2 gap-3">
        <MetricCard label="Chamadas" value={data.totalCalls.toString()} />
        <MetricCard
          label="Taxa de sucesso"
          value={`${successRate}%`}
          tone={successRate >= 95 ? 'good' : successRate >= 80 ? 'warn' : 'bad'}
        />
        <MetricCard label="Latência média" value={`${data.avgLatencyMs}ms`} />
        <MetricCard label="Tokens total" value={data.totalTokens.toLocaleString('pt-BR')} />
        <MetricCard
          label="Custo USD"
          value={`$${data.totalCostUsd.toFixed(4)}`}
          tone="neutral"
        />
        <MetricCard label="Fallbacks" value={data.fallbackCount.toString()} tone={data.fallbackCount > 0 ? 'warn' : 'neutral'} />
      </div>
    </div>
  );
}

function MetricCard({ label, value, tone = 'neutral' }: { label: string; value: string; tone?: 'good' | 'warn' | 'bad' | 'neutral' }) {
  const colors = {
    good: 'text-green-700 bg-green-50',
    warn: 'text-yellow-700 bg-yellow-50',
    bad: 'text-red-700 bg-red-50',
    neutral: 'text-gray-900 bg-gray-50',
  };

  return (
    <div className={`rounded-lg p-3 ${colors[tone]}`}>
      <div className="text-xs font-medium opacity-80">{label}</div>
      <div className="text-lg font-bold mt-1">{value}</div>
    </div>
  );
}